export default "/_next/static/images/c547dff077e946f1b16141e48f71325c.svg";